import api from '@/api';
import _ from 'lodash';

export default {
    state: {
        mesas: [],
    },
    getters: {
        mesas: state => state.mesas,
    },
    mutations: {
        SET_MESAS(state, mesas) {
            state.mesas = mesas;
        },
    },
    actions: {
        getMesas({ commit }, params) {
            commit('SET_MESAS', []);

            return new Promise(async (resolve, reject) => {
                const { election_id } = params;
                const response = await api.get(
                    `/official-tables/${election_id}`,
                    params
                );
                if (response.data) {
                    console.log('getMesas', response.data);
                    const mesas = _.map(
                        _.get(response, 'data.tables'),
                        mesa => {
                            return _.omit(mesa, ['id']);
                        }
                    );
                    commit('SET_MESAS', mesas);
                    resolve(
                        response.data.eleccion_finished
                            ? response.data.eleccion_finished
                            : false
                    );
                } else {
                    console.error(response);
                }
                resolve();
            });
        },
        printAlta({ commit }, { mesaInfo, election_id }) {
            return new Promise(async (resolve, reject) => {
                const { ocg, mesa } = mesaInfo;
                const response = await api.get(
                    `/pdf-open/${mesa}/${ocg}/${election_id}`,
                    {
                        responseType: 'arraybuffer',
                    }
                );

                if (response.status === 204) {
                    reject('No se encontró la información de la mesa');
                } else {
                    resolve(response.data);
                }
            });
        },
        printCierre({ commit }, { mesaInfo, election_id }) {
            return new Promise(async (resolve, reject) => {
                const { ocg, mesa } = mesaInfo;
                const response = await api.get(
                    `/pdf-close/${mesa}/${ocg}/${election_id}`,
                    {
                        responseType: 'arraybuffer',
                    }
                );
                if (response.status === 204) {
                    reject('No se encontró la información de la mesa');
                } else {
                    resolve(response.data);
                }
            });
        },
        uploadAlta({ commit }, { formData }) {
            return new Promise(async (resolve, reject) => {
                const response = await api.post(`/upload-alta`, formData);
                resolve(response.data);
            });
        },
        uploadCierre({ commit }, { formData }) {
            return new Promise(async (resolve, reject) => {
                const response = await api.post(`/upload-cierre`, formData);
                resolve(response.data);
            });
        },
        getDevices({ commit }, election_id) {
            return new Promise(async (resolve, reject) => {
                const response = await api.get(
                    `/get-devices-officials/${election_id}`
                );
                resolve(response);
            });
        },
        getPadron({ commit }, { election_id, limit, offset, search }) {
            return api.get(
                `/padron-activo/${election_id}?limit=${limit}&offset=${offset}&search=${search}`
            );
        },
        deleteDevice({ commit }, id) {
            return new Promise(async (resolve, reject) => {
                const response = await api.delete(`/devices-officials/${id}`);
                resolve(response);
            });
        },
        getVotesDevice({ commit }, election_id) {
            return new Promise(async (resolve, reject) => {
                const response = await api.post(`/get-votes-device`, {
                    election_id,
                });
                resolve(response);
            });
        },
    },
};
